import React, { useMemo } from 'react';
import { motion } from 'framer-motion';
import { ALL_CONSTELLATION_SYMBOLS } from './ConstellationSymbols';
export function ReikiBackground() {
  const icons = useMemo(() => {
    return Array.from({
      length: 18
    }).map((_, i) => ({
      id: i,
      Icon: ALL_CONSTELLATION_SYMBOLS[i % ALL_CONSTELLATION_SYMBOLS.length],
      left: `${5 + Math.random() * 90}%`,
      size: Math.random() * 30 + 22,
      duration: Math.random() * 30 + 30,
      delay: Math.random() * 25,
      opacity: Math.random() * 0.04 + 0.025
    }));
  }, []);
  return <div className="fixed inset-0 pointer-events-none overflow-hidden z-0" data-id="element-169" data-mp="105tf7hy3gh1l">
      {icons.map(({
      id,
      Icon,
      left,
      size,
      duration,
      delay,
      opacity
    }) => <motion.div key={id} style={{
      position: 'absolute',
      left,
      width: size,
      height: size,
      color: '#1e40af',
      opacity
    }} initial={{
      y: '110vh',
      rotate: 0
    }} animate={{
      y: '-10vh',
      rotate: 360
    }} transition={{
      duration,
      repeat: Infinity,
      delay,
      ease: 'linear'
    }} data-id="element-170" data-mp="r4vcd2ze6fkl">
          <Icon size={size} data-id="element-171" data-mp="fedlxecs5g65" />
        </motion.div>)}
    </div>;
}